import { LEGAL_TEXT } from "@/lib/labels";

export function Footer() {
  return (
    <footer data-testid="legal-footer" className="relative z-10 border-t border-border bg-background/80 mt-auto">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-4">
        <p className="text-[11px] leading-relaxed text-muted-foreground">{LEGAL_TEXT}</p>
      </div>
    </footer>
  );
}
